import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

/**
 * Landing content shown at /app so the home page is not blank.
 */
@Component({
  selector: 'app-welcome',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule],
  template: `
    <div class="welcome">
      <div class="welcome__hero">
        <mat-icon class="welcome__logo">luggage</mat-icon>
        <h1>Welcome to your Tourist Tax portal</h1>
        <p>Manage your tourist development tax in one place — file and pay returns,
           manage your properties, and view your messages.</p>
      </div>
      <div class="welcome__cards">
        <mat-card class="welcome__card" routerLink="/app/payments">
          <mat-icon>paid</mat-icon>
          <h3>Payments</h3>
          <p>File and pay your returns.</p>
        </mat-card>
        <mat-card class="welcome__card" routerLink="/app/properties">
          <mat-icon>domain_add</mat-icon>
          <h3>Properties</h3>
          <p>View and add rental properties.</p>
        </mat-card>
        <mat-card class="welcome__card" routerLink="/app/profile">
          <mat-icon>account_circle</mat-icon>
          <h3>Profile</h3>
          <p>Update your account details.</p>
        </mat-card>
      </div>
    </div>
  `,
  styles: [`
    .welcome { padding: 24px; max-width: 980px; margin: 0 auto; }
    .welcome__hero { text-align: center; padding: 24px 16px 8px; }
    .welcome__logo { font-size: 48px; width: 48px; height: 48px; color: #1d4ed8; }
    .welcome__hero h1 { font-size: 26px; color: #1e293b; margin: 12px 0 8px; }
    .welcome__hero p { color: #475569; font-size: 15px; max-width: 620px; margin: 0 auto; }
    .welcome__cards { display: grid; grid-template-columns: repeat(auto-fit, minmax(220px, 1fr)); gap: 16px; margin-top: 24px; }
    .welcome__card { padding: 20px; cursor: pointer; transition: box-shadow .15s, transform .15s; text-align: center; }
    .welcome__card:hover { box-shadow: 0 6px 20px rgba(0,0,0,.08); transform: translateY(-2px); }
    .welcome__card mat-icon { font-size: 32px; width: 32px; height: 32px; color: #1d4ed8; }
    .welcome__card h3 { margin: 10px 0 6px; color: #1e293b; font-size: 16px; }
    .welcome__card p { margin: 0; color: #64748b; font-size: 13px; }
  `]
})
export class WelcomeComponent {}
